import { EventEmitter } from 'fbemitter';

class GeckoLoadingService {
  // 1 minute
  timeout = 60000;

  static emitter;
  get emitter() {
    return GeckoLoadingService.emitter;
  }
  set emitter(value) {
    GeckoLoadingService.emitter = value;
  }

  static active = false;
  get active() {
    return GeckoLoadingService.active;
  }
  set active(value) {
    GeckoLoadingService.active = value;
  }

  constructor() {
    // Create modal event emitter (if not already created)
    if (!this.emitter) this.emitter = new EventEmitter();
  }

  show() {
    if (!this.active) {
      this.active = true;
      this.emitter.emit('update');
    }
    return;
  }

  hide() {
    if (this.active) {
      this.active = false;
      this.emitter.emit('update');
    }
    return;
  }

  resolve(promise) {
    // Is promise?
    if (Promise.resolve(promise) !== promise) return;

    // Show loader
    this.show();

    // Hide loader timeout fallback
    const timeout = setTimeout(() => this.hide(), this.timeout);

    return new Promise((resolve, reject) => {
      promise.then((values) => {
        //Hide loader
        this.hide();
        //Resolve promise
        resolve(values);
        // Clear timeout
        clearTimeout(timeout);
      });

      promise[promise.fail ? 'fail' : 'catch']((errors) => {
        //Hide loader
        this.hide();
        //Reject promise
        reject(errors);
        // Clear timeout
        clearTimeout(timeout);
      });
    });
  }
}

export default GeckoLoadingService;
